import React from 'react';
/**
* @deprecated utiliser `Icon`. Sera supprimé dans une futur Release d'ici fin 2025.
*/
var Icone = function (_a) {
    var icone = _a.icone, taille = _a.taille;
    var classIcone = icone;
    if (taille === 'sm' || taille === 'lg' || taille === 'xl') {
        classIcone += ' fr-icon--' + taille;
    }
    return React.createElement("span", { className: classIcone, "aria-hidden": true });
};
export default Icone;
